import React from 'react';
import 'fragments/signup/signup.scss';
import { SignupFragmentProps } from 'fragments/signup/interfaces';
import { useSignupController } from 'fragments/signup/signup.controller';
import { Button, Col, Form, Input, Row, Layout, Typography } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone, LeftOutlined } from '@ant-design/icons';
import { useTranslator } from 'tools/view-hooks/translator-hook';
const { Text, Title } = Typography;
const { Header } = Layout;

export const SignupFragment: React.FC<SignupFragmentProps> = (props) => {
    const { useController = useSignupController } = props;
    const controller = useController();
    const { translate } = useTranslator();

    // Render
    return (
        <div className={'signup'}>
            <Header className={'signup-header'}>
                <img src={'./logo-bco.png'} className={'header-img'} />
            </Header>
            <Row justify={'center'}>
                <Col flex={'600px'}>
                    <Form
                        name="basic"
                        layout={'vertical'}
                        className={'signup-form'}
                        initialValues={{ remember: true }}
                        onFinish={controller.onSignupSubmit}
                    >
                        <Row>
                            <Col span={2}>
                                <Title level={2}>
                                    <LeftOutlined onClick={controller.onBackPressed} />
                                </Title>
                            </Col>
                            <Col span={20}>
                                <Title level={2}> {translate({ key: 'signup.signup-title' })} </Title>
                            </Col>
                        </Row>
                        <Text type={'secondary'} style={{ fontSize: '14pt' }}>
                            {translate({ key: 'signup.signup-subtitle' })}
                        </Text>
                        <Form.Item
                            label={<Text strong>{translate({ key: 'label.email' })}</Text>}
                            name="email"
                            rules={[{ required: true }]}
                        >
                            <Input
                                placeholder={translate({ key: 'form.placeholder-email' })}
                                onChange={controller.onEmailChange}
                            />
                        </Form.Item>

                        <div className={'signup-forgot-container'}>
                            <Button
                                className={'button primary'}
                                type="primary"
                                block={true}
                                htmlType="submit"
                                loading={controller.isLoading}
                                disabled={controller.isButtonDisabled}
                            >
                                {translate({ key: 'signup.signup-button-label' })}
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};
